<template>
  <crud-modal
    :title="$t('components.modals.campaign.addStaticDocTitle')"
    action="create"
    :on-submit="submit"
    :on-close="() => $emit('close')"
  >
    <div>
      <input-text-validated
        ref="name"
        v-model="name"
        input-class="w-full mb-4"
        :label="$t('components.modals.campaign.createDocument.name')"
        rules="required"
      />
    </div>
    <div>
      <input-file-validated
        ref="file"
        v-model="file"
        :label="$t('components.modals.campaign.createDocument.file')"
        rules="required"
      />
    </div>
    <div class="mt-4">
      <input-select-validated
        ref="purpose"
        v-model="purpose"
        :label="$t('components.modals.campaign.createDocument.purpose')"
        :options="PURPOSE"
        rules="required"
      />
    </div>
    <div class="mt-4">
      <input-select-validated
        ref="assetType"
        v-model="assetType"
        :label="$t('components.modals.campaign.createDocument.assetType')"
        :options="ASSET_TYPES"
        rules="required"
      />
    </div>
    <div class="my-6 text-lg font-bold">
      {{ $t('components.modals.campaign.createDocument.validVariants') }}
    </div>
    <div class="flex flex-wrap w-full px-2 mb-6">
      <div
        v-for="variant in variants"
        :key="variant.value"
        class="w-1/4 pr-4"
      >
        <label class="inline-flex items-center">
          <input
            v-model="selectedVariants"
            type="checkbox"
            class="w-4 h-4 form-checkbox"
            :value="variant.value"
          >
          <span class="ml-2 text-base normal-case">{{ variant.name }}</span>
        </label>
      </div>
    </div>
    <div class="flex justify-around">
      <button
        class="w-1/3 btn-secondary"
        @click="() => (selectedVariants = variants.map(({ value }) => value))"
      >
        {{ $t('components.modals.campaign.createDocument.all') }}
      </button>
      <button
        class="w-1/3 btn-secondary"
        @click="() => (selectedVariants = [])"
      >
        {{ $t('components.modals.campaign.createDocument.none') }}
      </button>
    </div>
  </crud-modal>
</template>

<script>
import CrudModal from '@/components/modals/crud-modal'
import InputFileValidated from '@/components/form/file-validated'
import InputTextValidated from '@/components/form/text-validated'
import InputSelectValidated from '@/components/form/select-validated'

import GET_CAMPAIGN from '@/graphql/GetCampaign.gql'
import CREATE_STATIC_MATERIAL_TEMPLATE_FOR_CAMPAIGN from '@/graphql/CreateStaticMaterialTemplateForCampaign.gql'
import variantMixin from '@/mixins/variant'

export default {
  components: { CrudModal, InputFileValidated, InputTextValidated, InputSelectValidated },
  mixins: [variantMixin],
  props: {
    campaignId: { type: String, required: true }
  },
  data () {
    return {
      name: '',
      variants: [],
      selectedVariants: [],
      file: {},
      purpose: 'SCREEN',
      assetType: '',
      PURPOSE: [
        { value: 'SCREEN', name: 'SCREEN' },
        { value: 'PRINT', name: 'PRINT' }
      ],
      ASSET_TYPES: [
        { value: 'SHOPPING_CART', name: 'SHOPPING_CART' },
        { value: 'CHECKLIST', name: 'CHECKLIST' },
        { value: 'UNKNOWN', name: 'UNKNOWN' },
        { value: 'AD', name: 'AD' },
        { value: 'FLYER_A5', name: 'FLYER_A5' },
        { value: 'FLYER', name: 'FLYER' },
        { value: 'POSTER', name: 'POSTER' },
        { value: 'BANNER', name: 'BANNER' },
        { value: 'SOCIAL_IMAGE', name: 'SOCIAL_IMAGE' },
        { value: 'SOCIAL_STORY', name: 'SOCIAL_STORY' },
        { value: 'COASTER', name: 'COASTER' },
        { value: 'POSTCARD_BLANK', name: 'POSTCARD_BLANK' },
        { value: 'POSTCARD_TEXT', name: 'POSTCARD_TEXT' },
        { value: 'NEWSPAPER', name: 'NEWSPAPER' },
        { value: 'GUIDE', name: 'GUIDE' },
        { value: 'VIDEO', name: 'VIDEO' }
      ]
    }
  },
  created () {
    this.variants = this.getMappedVariants()
  },

  methods: {
    async submit () {
      await this.$apollo.mutate({
        mutation: CREATE_STATIC_MATERIAL_TEMPLATE_FOR_CAMPAIGN,
        variables: {
          input: {
            campaignId: this.campaignId,
            name: this.name,
            purpose: this.purpose,
            file: this.file.file,
            variants: this.selectedVariants,
            assetType: this.assetType
          }
        },
        refetchQueries: [{ query: GET_CAMPAIGN, variables: { campaignId: this.campaignId } }]
      })
    }
  }
}
</script>
